import React from 'react'
import './PaymentSuccess.css'
import { Modal,Button } from 'react-bootstrap'
import { useNavigate } from 'react-router-dom'

const PaymentSuccess = ({showSuccess,setShowSuccess}) => {
    const navigate = useNavigate();
    const [countDown,setCountDown]=React.useState(5);


   
    React.useEffect(() => {
        const interval = setInterval(() => {
            setCountDown(countDown-1);
            if(countDown===0){
               setShowSuccess(false);
                navigate("/add-listing");
            }
        }, 1000);
        return () => clearInterval(interval);
    }, [countDown]);





    
  return (
    <Modal
    show={true}
      size="md"
      aria-labelledby="contained-modal-title-vcenter"
      centered
    >
     
      <Modal.Body>
      <div className='success-body'>
      <div className="success-card">
      <div style={{borderRadius:"200px", height:"200px", width:"200px", background: "#F8FAF5", margin:"0 auto"}}>
        <i class="suceess-checkmark">âœ“</i>
      </div>
        <h5 className='success-heading'>Payment Success</h5> 
        <p className='success-paragraph'>Please Create listing;<br/> to get approved from admin!</p>
      </div>
      <p>You will be redirected in:</p>
        <h1 className='countdown'>{countDown}</h1>
    </div>
       
      </Modal.Body>
      
    </Modal>

   
  )
}

export default PaymentSuccess